import {Order} from "./Order.enum";
import {Dispatch} from "react";

export interface StudentInterface {
	id?: string;
	name: string;
	email: string;
	status?: StudentStatus;
	notes?: string;
	error?: string;
	description?: string;
	isDublicate?: boolean;
	deactivationReason?: string;
	dublicateCount?: string;
	requestId?: string,
	requestUnit?: string,
	requestDescription?: string,
	requestBasicFlowEmail?: string,
	requestEmail?: string,
	requestSubmitDate?: string,
	updatedAt?: string,
}

export enum StudentStatus {
	NEW = 'new',
	SENT = 'sent',
	APPROVED = 'approved',
	REJECTED = 'rejected',
	ERROR = 'error',
	DEACTIVATED = 'deactivated',
}

export interface StudentFilter {
	id?: string;
	email?: string;
	name?: string;
	request?: string;
	unit?: string;
	page?: number;
	status?: StudentStatus;
	limit?: number;
	orderBy?: StudentOrderBy;
	order?: Order;
	[key: string]: any;
}

export interface StudentFormEditInterface extends StudentFormViewInterface {
	update: (index: number, obj: StudentInterface) => void;
	value: StudentInterface;
	error?: any;
	withNotes?: boolean;
}
export interface StudentFormViewInterface {
	index: number;
	control?: any;
}
export interface StudentsInterface {
	control: any;
	error: boolean;
	helperText: string;
	label: string;
	listOfStudents: string;
	setListOfStudents: Dispatch<string>;
}

export enum StudentOrderBy {
	EMAIL = 'email',
	NAME = 'name',
	ID = 'id',
	STATUS = 'status',
	UNIT = 'unit',
	SUBMIT_DATE = 'submitDate',
	UPDATED_AT = 'updatedAt',
}
